import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const EditMenuSlice = createSlice({
    name: "editMenu",
    initialState,
    reducers: {
        editMenuRequest(state) {
            state.loading = true;
        },
        editMenuRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        editMenuRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        editMenuStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    editMenuRequest,
    editMenuRequestSuccess,
    editMenuRequestError,
    editMenuStateReset
} = EditMenuSlice.actions;

export default EditMenuSlice.reducer;
